export const FIGURES = {
  Polygon: 'polygon',
  MultiPolygon: 'polygon',
};
